
<template>
    <modal name="SettingConfirmDialog"
           :width="Width"
           :draggable="!IsMobile"
           @before-open="OnBeforeOpen"
            @before-close="OnBeforeClose"
           @opened="OnOpened">

        <table class="ConfirmTable" ref="SettingConfirmDialog" cellspacing="0">
            <tr>
                <td class="Header " colspan="2">
                    {{Title}}
                    <t-button @click="OnCloseButtonClick" class="CloseDialogButton" style="display:none">x</t-button>
                </td>
            </tr>

            <!--<tr>
                <td class="Description" valign="middle">
                    <span v-html="Description "></span>
                </td>
            </tr>-->

            <tr>
                <td style="width: 50%;">
                    說明(上限200字)
                </td>
                <td style="width: 50%;">
                    {{CalcWordsNum()}}/200
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <textarea v-model="WordsNum" maxlength="200"></textarea>
                </td>
            </tr>

            <tr class="ButtonList">
                <td class="ButtonList" colspan="2">
                    <t-button class="Button Confirm" @click="OnConfirmButtonClick">送交覆核</t-button>
                    &nbsp;
                    <t-button class="Button Cancel" @click="OnCancelButtonClick">取消</t-button>
                </td>
            </tr>
        </table>

    </modal>
</template>

<script scoped>
    import Utility from '@/Common/Utility'

    export default {
        name: "SettingConfirmDialog",
        data() {
            return {
                Title: "",
                IsMobile: false,
                Description: "",
                ConfirmHandler: null,
                Width: 360,
                WordsNum: "",
            }
        }
        ,
        props: ["value"],

        methods: {

            CalcWordsNum() {
                return this.WordsNum.length;
            },

            OnCloseButtonClick() {
                this.$modal.hide("SettingConfirmDialog");
            },

            OnConfirmButtonClick() {
         
                Utility.Confirm(
                    "確認送出",
                    "是否確認送交主管覆核?",
                    function (wordsNum) {
                        var Content = wordsNum;
                         

                        if (this.ConfirmHandler != null) {
                            this.ConfirmHandler(Content);
                        }
                    }.bind(this, this.WordsNum)
                );


                this.Title = "";
                this.WordsNum = ""; //清空

                //搬出來，本身視窗可以關掉
                this.$forceUpdate();

                this.$modal.hide("SettingConfirmDialog");
            },

            OnCancelButtonClick() {
                this.WordsNum = ""; //取消時預設清空
                this.$modal.hide("SettingConfirmDialog");
            },

            OnBeforeOpen(arg) {
                let modalElement;

                if (arg.params.Title != null) {
                    this.Title = arg.params.Title;
                }
                else {
                    this.Title = "確認視窗";
                }

  
                this.Description = arg.params.Description;
                this.ConfirmHandler = arg.params.ConfirmHandler;

                setTimeout(
                    () => {
                        document.querySelector(".vm--modal").style.height = "auto";
                    },
                    1
                );
            },

            OnBeforeClose() {
                this.Title = "";
                this.WordsNum = "";
            },

            OnOpened() {

            }
        },

        computed: {

        },

        mounted() {

        },

        beforeMounted() {

        },

        created() {
            this.IsMobile = Utility.IsMobile();

            if (this.IsMobile) {
                this.Width = 280;
            }
        },

        watch: {
            value: function (newVal, oldVal) {

            }
        }
    }
</script>

<style>
    .ConfirmTable {
        width: 100%;
        height: 100%;
        border-left: 1px solid lightgray;
        border-right: 1px solid lightgray;
        background-color: transparent;
        font-family: 微軟正黑體,Microsoft JhengHei,Zawgyi-one;
    }

        .ConfirmTable .Description {
            background-color: rgba(255,255,255,0.8);
            white-space: pre-wrap;
            min-height: 100px;
            line-height: 20px;
            height: 90%;
            padding-left: 10px;
            padding-right: 10px;
            padding-top: 20px;
            padding-bottom: 20px;
        }

        .ConfirmTable .Header {
            position: relative;
            text-align: center;
        }

    .CloseDialogButton {
        position: absolute;
        right: 5px;
        top: 5px;
        cursor: pointer;
        font-size: 15px;
        width: 28px;
        height: 28px;
        background-color: #F0F0F0;
        border: 1px solid #e0e0e0;
    }

  
    .ConfirmTable .Header,
    .ConfirmTable .ButtonList {
        min-height: 30px;
        font-size: 16px;
        font-weight: bold;
        padding: 5px;
        border-top: 1px solid lightgray;
        border-bottom: 1px solid lightgray;
        cursor: pointer;
        padding: 10px;
    }

    .ConfirmTable .ButtonList {
        text-align: center;
    }
</style>
